/**
 * dev-ops 运维接口地址
 *
 * REACT_APP_DEV_OPS_API_BASE 支持两种写法：
 * - 路径前缀（本地 dev / 同域 Nginx）：/dev-ops-api → 由 dev proxy / Nginx 反代到 /service
 * - 完整域名（测试打包）：https://admin-api.test.suifuda.com → 浏览器直连 /service/...
 *
 * 代码里统一写 /dev-ops-api/...，运行时按上面配置拼最终 URL。
 */

const DEV_OPS_API_PREFIX = '/dev-ops-api';
const SERVICE_PATH_PREFIX = '/service';

function normalizeEnvValue(value: unknown) {
  return String(value ?? '')
    .trim()
    .replace(/^['"]+|['"]+$/g, '');
}

export function isAbsoluteApiBase(value: string) {
  return /^https?:\/\//i.test(value);
}

export function getDevOpsApiPrefix() {
  const raw = normalizeEnvValue(process.env.REACT_APP_DEV_OPS_API_BASE);
  if (!raw || isAbsoluteApiBase(raw)) return DEV_OPS_API_PREFIX;
  return raw.startsWith('/')
    ? raw.replace(/\/+$/, '')
    : `/${raw}`.replace(/\/+$/, '');
}

/** 完整域名模式时返回 baseURL，路径前缀模式返回 undefined */
export function getDevOpsRequestBaseURL(): string | undefined {
  const raw = normalizeEnvValue(process.env.REACT_APP_DEV_OPS_API_BASE);
  if (!raw || !isAbsoluteApiBase(raw)) return undefined;
  return raw.replace(/\/+$/, '');
}

/** 将代码里的 /dev-ops-api/... 转为最终请求地址 */
export function resolveDevOpsApiUrl(url: string) {
  const raw = String(url || '').trim();
  if (!raw || /^https?:\/\//i.test(raw)) return raw;
  if (!raw.startsWith(`${DEV_OPS_API_PREFIX}/`) && raw !== DEV_OPS_API_PREFIX) {
    return raw;
  }

  const domainBase = getDevOpsRequestBaseURL();
  if (domainBase) {
    return `${domainBase}${raw.replace(
      new RegExp(`^${DEV_OPS_API_PREFIX}`),
      SERVICE_PATH_PREFIX,
    )}`;
  }

  const prefix = getDevOpsApiPrefix();
  return raw.replace(new RegExp(`^${DEV_OPS_API_PREFIX}`), prefix);
}

export function isDevOpsApiUrl(url?: string) {
  const raw = String(url || '').trim();
  if (!raw) return false;
  if (raw.startsWith(`${DEV_OPS_API_PREFIX}/`)) return true;

  const prefix = getDevOpsApiPrefix();
  if (raw.startsWith(`${prefix}/`)) return true;

  const domainBase = getDevOpsRequestBaseURL();
  if (domainBase && raw.startsWith(domainBase)) return true;

  return false;
}
